import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { JourneyCreationLoaderService } from './journey-creation-loader.service';

/**
 * Full-screen loader shown while a dynamic learning journey is generated.
 *
 * Mounted once in the app shell and toggled via {@link JourneyCreationLoaderService}
 * so it stays visible across the navigation into the LJ editor.
 */
@Component({
	selector: 'angie-journey-creation-loader',
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [TranslateModule],
	templateUrl: './journey-creation-loader.component.html',
	styleUrls: ['./journey-creation-loader.component.scss']
})
export class JourneyCreationLoaderComponent {
	protected readonly loader = inject(JourneyCreationLoaderService);
	protected readonly artSrc = `${environment.cdnBase}/assets/images/journey-loading.svg`;
}
